import {CatalogueMarketplace, HitItemCatalogue} from 'api-types/ffconnect';

// NOTE(Nathan): HitItemMarketplace est juste le retour de l'API get-search_marketplace.
// Dans l'index Orama tous les champs sont HitItemCatalogue,
// on a besoin de l'interface pour éviter les asserts.
export interface HitItemCatalogueMarketplace extends HitItemCatalogue {
  marketplace_id: CatalogueMarketplace;
  ref_tiers: string;
}

export const isMarketplaceHit = (
  hit: HitItemCatalogue,
): hit is HitItemCatalogueMarketplace => {
  return Boolean(hit.ref_tiers) && hit.marketplace_id !== 'FF';
};
